






















































































import Vue from 'vue';

import { getConfig } from '@/web/utils/configuration';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  name: 'ThankYouBio',
  computed: {
    supportEmail() {
      return getConfig().supportEmail;
    },
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  methods: {
    sanitize,
    togglePlay() {
      if (this.isPlaying) {
        this.stopPlay();
      } else {
        this.isPlaying = true;
        this.$refs.audio.play();
        this.$track('play-audio');
      }
    },
    stopPlay() {
      const audio = this.$refs.audio;
      audio.pause();
      audio.currentTime = 0;
      this.isPlaying = false;
    },
  },
});
